module.exports = __webpack_public_path__ + "img/over-speeding.09a996e9.svg";